/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import _ from 'lodash';
import { convertFloatFix } from './pqasUtils';
import {
  dispatchGetSummaryGridList,
  setDisabledValIntPaidPQAS,
} from '../../store/Actions';
import MaxLengthNumericEditor from '../../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../../SharedModules/StyleConstant/StyleConstant';
import { replaceCommaIntoWhiteSpace } from '../../../components/gridComponents/ROSIUtils';
import {
  removeWhiteSpaceForNDC,
  ndcTextMatcher,
} from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  dispatchAllocatePaymentHederData,
  //dispatchAllocatePaymentAmtNotify,
} from '../../../store/Actions';

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}
export const setErrorMessageForPQASDiscrepancy = (val) => {
  let errorMsg = '';
  if (val?.toString() === 'PAPT') {
    errorMsg =
      'PQAS - Amount Paid this Transaction is not equal to Current Amount Paid to Date - Prior Amount Paid[PAPT].';
  } else if (val?.toString() === 'PCAP') {
    errorMsg =
      'PQAS - Current Amount Paid to Date is not equal to Current Units to Date times Current URA[PCAP].';
  } else if (val?.toString() === 'PCUD') {
    errorMsg =
      'PQAS - Current Units to Date is not equal to Current Units Paid to Date + Current Units Disputed to Date[PCUD].';
  } else if (val?.toString() === 'PRIA') {
    errorMsg =
      'PQAS - Revised Invoice Amount is not equal to Current URA * Current Units to Date[PRIA].';
  } else if (val?.toString() === 'PCA0') {
    errorMsg =
      'PQAS - Current Amount Paid = 0, Paid This Transaction Amount <> 0 and Paid This Transaction Amount <> Current Amount Paid ? Prior Amount Paid[PCA0].';
  } else if (val?.toString() === 'PMAC') {
    errorMsg =
      'PQAS - Current URA and/or Current Units to Date have changed, but there is no adjustment code[PMAC].';
  } else if (val?.toString() === 'PMDC') {
    errorMsg =
      'PQAS - Current Units Disputed to Date is present, but no Dispute Code is present[PMDC].';
  } else if (val?.toString() === 'PCU0') {
    errorMsg =
      'PQAS - Current Units Paid = 0 and Current Amount Paid > 0[PCU0].';
  } else if (val?.toString() === 'PAPM') {
    errorMsg =
      'PQAS -  Paid This Transaction Amount is missing or zero and Current Amount Paid – Prior Amount Paid <> 0[PAPM].';
  }
  return errorMsg;
};
export const colorCodeOnFieldsLevel = (colorCode, val, onFocus, disable) => {
  let className = '';
  if (parseFloat(val || 0) < 0 && disable) {
    className = 'frr-color-red frr-color-class-grey';
  } else if (parseFloat(val || 0) < 0 && !onFocus) {
    className = 'frr-color-red ';
  } else if (colorCode?.toString() === '12632256') {
    className = 'frr-color-class-grey';
  } else if (colorCode?.toString() === '11534335') {
    className = 'frr-color-class-yellow';
  } else if (colorCode?.toString() === '00b300') {
    className = 'frr-color-class-green';
  }
  return className;
};

export const calculateTotalSum = (
  ColName,
  rowData,
  sumGrid,
  allocatePaymentHeaderDetail
) => {
  const newObj = rowData?.length > 0 ? JSON.parse(JSON.stringify(rowData)) : [];
  const displayedRows =
    newObj &&
    newObj?.map((item) => {
      if (ColName === 'xorigAmtPtt' && parseFloat(item.xorigAmtPtt) === 0) {
        item.xorigAmtPtt = (
          parseFloat(item.cidunitRebateAmt || 0) *
          parseFloat(item.totReimbursedUnits || 0)
        ).toFixed(2);
      }
      item[ColName] = item[ColName]
        ? parseFloat(item[ColName]?.toString()?.replace(',', '').trim())
        : 0;
      return item;
    });
  let data = 0;
  if ((ColName === 'revisedInvoiceAmt' ||
      ColName === 'currUnits' ||
      ColName === 'xorigAmtPtt' ||
      ColName === 'totReimbursedUnits') &&
    sumGrid) {
    let filteredDisplayedRowsArr = [];
    let drugSeqNumWithBg = [];
    if (allocatePaymentHeaderDetail) {
      // Step 1: Identify drugSeqNum that have bg != "12632256"
      drugSeqNumWithBg = new Set(
        displayedRows
          .filter(
            (item) =>
              item.invRecSeqNum !=
              allocatePaymentHeaderDetail?.recancilationNumber
          )
          .map((item) => item.drugSeqNum)
      );
      // Step 2: Remove items with bg === "12632256" if their ID exists in drugSeqNumWithBg
      filteredDisplayedRowsArr = displayedRows.filter(
        (item) =>
          !(
            item.invRecSeqNum ===
              allocatePaymentHeaderDetail?.recancilationNumber &&
            drugSeqNumWithBg.has(item.drugSeqNum)
          )
      );
    } else {
      // Step 1: Identify drugSeqNum that have bg != "12632256"
      drugSeqNumWithBg = new Set(
        displayedRows
          .filter((item) => item.bgColorForNDC != '12632256')
          .map((item) => item.drugSeqNum)
      );
      // Step 2: Remove items with bg === "12632256" if their ID exists in drugSeqNumWithBg
      filteredDisplayedRowsArr = displayedRows.filter(
        (item) =>
          !(
            item.bgColorForNDC === '12632256' &&
            drugSeqNumWithBg.has(item.drugSeqNum)
          )
      );
    }
    data = filteredDisplayedRowsArr?.reduce((a, b) => {
      return a + (b[ColName] ? parseFloat(b[ColName] || 0) : 0);
    }, 0);
  } else {
    data = displayedRows?.reduce((a, b) => {
      return a + (b[ColName] ? parseFloat(b[ColName] || 0) : 0);
    }, 0);
  }

  const newData = data;
  // ? parseFloat(data)?.toLocaleString('en-US', { minimumFractionDigits: 2 })
  // : 0;

  return convertFloatFix(ColName, newData, null);
};
const getAdjDisputeExportValue = (labelField) => (params) => {
  if (params.data?.isBottomRow) return '';
  return params.data?.[labelField] || '';
};

const getAdjDisputeFilterValue = (codeField) => (params) =>
  params.data?.[codeField] ?? '';

const adjDisputeValueSetter = (params) => {
  if (!params.data || !params.colDef?.field) return false;
  params.data[params.colDef.field] = params.newValue;
  return true;
};

export const createNewRowData = (count, rowData) => {
  const result = [];
  for (let i = 0; i < count; i += 1) {
    result.push({
      isBottomRow: true,
      interestSettledInd: '',
      interestCalc: '',
      ccInterestAllocated: '',
      adjustedUnitRebateAmt: '',
      currUnitRebateAmt: 'Totals:',
      cidunitRebateAmt: '',
      ndc: '',
      drugName: '',
      ccAc1: '',
      ccAc2: '',
      ccAc3: '',
      ccDc1: '',
      ccDc2: '',
      ccDc3: '',
      ccAc1ValWithLabel: '',
      ccAc2ValWithLabel: '',
      ccAc3ValWithLabel: '',
      ccDc1ValWithLabel: '',
      ccDc2ValWithLabel: '',
      ccDc3ValWithLabel: '',
      totReimbursedUnits: calculateTotalSum(
        'totReimbursedUnits',
        rowData,
        true
      ),
      currUnits: calculateTotalSum('currUnits', rowData, true),
      priorPaidUnits: calculateTotalSum('priorPaidUnits', rowData),
      currUnitsPaid: calculateTotalSum('currUnitsPaid', rowData),
      priorDisputedUnits: calculateTotalSum('priorDisputedUnits', rowData),
      currUnitsDisputed: calculateTotalSum('currUnitsDisputed', rowData),
      xorigAmtPtt: calculateTotalSum('xorigAmtPtt', rowData, true),
      revisedInvoiceAmt: calculateTotalSum('revisedInvoiceAmt', rowData),
      priorPaidAmt: calculateTotalSum('priorPaidAmt', rowData),
      currAmtPaid: calculateTotalSum('currAmtPaid', rowData),
      paidThisTransactionAmt: calculateTotalSum(
        'paidThisTransactionAmt',
        rowData
      ),
    });
  }
  return result;
};
const handleCountDecimals = (amt) => {
  if (Math.floor(amt.valueOf()) === amt.valueOf()) return 0;
  return amt.toString()?.split('.')[1]?.length || 0;
};
export const roundOffXorigAmtPttAmount = (item) => {
  const originXorigAmtPtt = parseFloat(
    replaceCommaIntoWhiteSpace(item.xorigAmtPtt)
  );
  let xorigAmtPtt = 0;
  let length = 0;

  let roundedVal = Math.round(originXorigAmtPtt * 100) / 100;
  length = handleCountDecimals(parseFloat(originXorigAmtPtt || 0));
  xorigAmtPtt = parseFloat(roundedVal).toFixed(length);
  if (xorigAmtPtt === 0) {
    xorigAmtPtt = 0;
  }
  return xorigAmtPtt;
};
export const roundOffTotReimbursedAmt = (item) => {
  const originTotReimbursedAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.totReimbursedAmt)
  );
  let totReimbursedAmt = 0;
  let length = 0;

  let roundedVal = Math.round(originTotReimbursedAmt * 100) / 100;
  length = handleCountDecimals(parseFloat(originTotReimbursedAmt || 0));
  totReimbursedAmt = parseFloat(roundedVal).toFixed(length);
  if (totReimbursedAmt === 0) {
    totReimbursedAmt = 0;
  }
  return totReimbursedAmt;
};
export const roundOffCurrURA = (item) => {
  const originCurrUnitRebateAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.currUnitRebateAmt)
  );
  let currUnitRebateAmt = 0;
  let length = 0;

  let roundedVal = Math.round(originCurrUnitRebateAmt * 100) / 100;
  length = handleCountDecimals(parseFloat(originCurrUnitRebateAmt || 0));
  currUnitRebateAmt = parseFloat(roundedVal).toFixed(length);
  if (currUnitRebateAmt === 0) {
    currUnitRebateAmt = 0;
  }
  return currUnitRebateAmt;
};
// export const roundOffPaidThisTransactionAmtAmount = (item) => {
//   const originPaidThisTransactionAmt = parseFloat(
//     replaceCommaIntoWhiteSpace(item.paidThisTransactionAmt)
//   );
//   let paidThisTransactionAmt = 0;
//   let length = 0;

//   let roundedVal = Math.round(originPaidThisTransactionAmt * 100) / 100;
//   length = handleCountDecimals(parseFloat(originPaidThisTransactionAmt || 0));
//   paidThisTransactionAmt = parseFloat(roundedVal).toFixed(length);
//   if (
//     originPaidThisTransactionAmt === 0 ||
//     parseFloat(
//       convertFloatFix(
//         'paidThisTransactionAmt',
//         originPaidThisTransactionAmt?.toString()?.replace('-', '').trim()
//       )
//     ) === 0
//   ) {
//     paidThisTransactionAmt = 0;
//   }
//   return paidThisTransactionAmt;
// };
export const roundOffPaidThisTransactionAmtAmount = (item) => {
  const rawVal = replaceCommaIntoWhiteSpace(item?.paidThisTransactionAmt);
  const origin = parseFloat(rawVal);
  const safeOrigin = isNaN(origin) ? 0 : origin;
  let length = handleCountDecimals(safeOrigin);
  let roundedVal = Math.round(safeOrigin * 100) / 100;
  let paidThisTransactionAmt = Number(roundedVal.toFixed(length));
  if (
    safeOrigin === 0 ||
    parseFloat(
      convertFloatFix(
        'paidThisTransactionAmt',
        safeOrigin.toString().replace('-', '').trim()
      )
    ) === 0
  ) {
    paidThisTransactionAmt = 0;
  }
  return paidThisTransactionAmt;
};
export const roundOffCurrMatPaidAmount = (item) => {
  const originCurrAmtPaid = parseFloat(
    replaceCommaIntoWhiteSpace(item.currAmtPaid)
  );
  let currAmtPaid = 0;
  let length = 0;
  let roundedVal = Math.round(originCurrAmtPaid * 100) / 100;
  length = handleCountDecimals(parseFloat(originCurrAmtPaid || 0));
  currAmtPaid = parseFloat(roundedVal).toFixed(length);
  if (originCurrAmtPaid === 0) {
    currAmtPaid = 0;
  }
  return currAmtPaid;
};
export const roundOffRevisedInoiveAmount = (item) => {
  const originRevisedInvoiceAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.revisedInvoiceAmt)
  );
  let revisedInvoiceAmt = 0;
  let length = 0;
  let roundedVal = Math.round(originRevisedInvoiceAmt * 100) / 100;
  length = handleCountDecimals(parseFloat(originRevisedInvoiceAmt || 0));
  revisedInvoiceAmt = parseFloat(roundedVal).toFixed(length);
  if (
    isNaN(originRevisedInvoiceAmt) ||
    parseFloat(originRevisedInvoiceAmt) === 0
  ) {
    revisedInvoiceAmt = 0;
  }
  return revisedInvoiceAmt;
};
export const roundOffPriorPaidAmtAmount = (item) => {
  const originPriorPaidAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.priorPaidAmt)
  );
  let priorPaidAmt = 0;
  let length = 0;
  let roundedVal = Math.round(originPriorPaidAmt * 100) / 100;
  length = handleCountDecimals(parseFloat(originPriorPaidAmt || 0));
  priorPaidAmt = parseFloat(roundedVal).toFixed(length);
  if (originPriorPaidAmt === 0) {
    priorPaidAmt = 0;
  }
  return priorPaidAmt;
};
export const tabPressMoveNextColumn = (
  gridApi,
  columnName,
  rowIndex,
  nextCol
) => {
  _.debounce(() => {
    // console.log('PQAS-329');
    gridApi.api.ensureColumnVisible(columnName);
    gridApi.api.setFocusedCell(nextCol ? rowIndex : rowIndex + 1, columnName);
    gridApi.api.forEachNode(
      (node) =>
        node.rowIndex === (nextCol ? rowIndex : rowIndex + 1) &&
        node?.setSelected(true)
    );
  });
};

export const SummaryRecall = async (
  pqasGridData,
  allocatePaymentHeaderDetail,
  summaryGirdRowData,
  summaryGirdAllData,
  dispatch,
  activeInvNum,
  activeCheckLogNum,
  disabledIntPaidAllPQAS,
  headerAllocatePaymentData,
  pqasOriginalData = []
) => {
  let interestObj = 0;
  const Prin = 0;
  let otherInterest = 0;
  pqasGridData.forEach((val) => {
    let OneMod = false;
    let IntMod = false;
    if (
      val.invRecSeqNum === allocatePaymentHeaderDetail?.recancilationNumber ||
      val.invRecSeqNum === 0 ||
      val.updateVal === true
    ) {
      const newIntPaid = val.ccInterestAllocated || 0;
      if (newIntPaid) {
        interestObj += parseFloat(newIntPaid);
      }
      if (
        val.invRecSeqNum === allocatePaymentHeaderDetail?.recancilationNumber ||
        val.invRecSeqNum === 0
      ) {
        OneMod = true;
        if (val?.interestUpdate || val?.newlyInserted) IntMod = true;
        else if (val.modifiedValues || val.newlyInserted) OneMod = true;
      }
      if (OneMod && newIntPaid) {
        interestObj += parseFloat(newIntPaid);
      }
    }
    return val;
  });

  let newIntStld = calculateTotalSum('ccInterestAllocated', pqasGridData)
    ?.toString()
    ?.replace(',', '')
    .trim();
  const cfSumOwedAmt = calculateTotalSum(
    'revisedInvoiceAmt',
    pqasGridData,
    true
  )
    ?.toString()
    ?.replace(',', '')
    .trim();
  const totalPrincipalPaid = calculateTotalSum(
    'paidThisTransactionAmt',
    pqasGridData
  )
    ?.toString()
    ?.replace(',', '')
    .trim();
  const principalPaidThisCheck = calculateTotalSum(
    'paidThisTransactionAmt',
    pqasGridData.filter((x) => {
      return (
        x.invRecSeqNum === allocatePaymentHeaderDetail?.recancilationNumber ||
        x.invRecSeqNum === 0
      );
    })
  )
    ?.toString()
    ?.replace(',', '')
    .trim();
  summaryGirdRowData[0].cfSumOwedAmt = cfSumOwedAmt;
  summaryGirdRowData[0].currentPrincipalAmt = cfSumOwedAmt;
  summaryGirdRowData[0].totalPrincipalPaid = totalPrincipalPaid;
  summaryGirdRowData[0].principalPaidThisCheck = principalPaidThisCheck;
  if (
    summaryGirdRowData[0].orgTotalIntPaid === undefined ||
    summaryGirdRowData[0].orgTotalIntPaid === null
  ) {
    summaryGirdRowData[0].orgTotalIntPaid = summaryGirdRowData[0].totalIntPaid;
  }
  const origIntPaidSum = calculateTotalSum(
    'ccInterestAllocated',
    pqasOriginalData
  )
    ?.toString()
    ?.replace(',', '')
    .trim();
  const baseTotalIntPaid = parseFloat(
    summaryGirdRowData[0].orgTotalIntPaid
      ?.toString()
      ?.replace(/\$/g, '')
      ?.replace(/,/g, '')
      ?.trim() || 0
  );
  summaryGirdRowData[0].totalIntPaid = parseFloat(
    parseFloat(baseTotalIntPaid || 0) +
      (parseFloat(newIntStld || 0) - parseFloat(origIntPaidSum || 0))
  ).toFixed(2);
  // const newTotPrin = calculateTotalSum('paidAmt', pqasGridData);
  // let newOwedAmt = calculateTotalSum('amtOwedNDC', pqasGridData);
  let intPaidThisCheck = summaryGirdRowData[0].orgIntPaidThisCheck;
  let calcuNewIntStld = parseFloat(
    parseFloat(intPaidThisCheck || 0) + parseFloat(newIntStld || 0)
  ).toFixed(2);
  if (newIntStld && newIntStld != 0) {
    summaryGirdRowData[0].bgColorForIntPaidThisCheck = '12632256';
    summaryGirdRowData[0].disabledForIntPaidThisCheck = true;
    const disabledIntPaidObj = { ...disabledIntPaidAllPQAS };
    disabledIntPaidObj[`${activeInvNum}-${activeCheckLogNum}`] = {
      ...disabledIntPaidObj[`${activeInvNum}-${activeCheckLogNum}`],
      pqasGridIntPaidColumnDisabled: false,
      summaryGirdIntPaidColumnDisabled: true,
    };
    dispatch(setDisabledValIntPaidPQAS(disabledIntPaidObj));
  } else {
    summaryGirdRowData[0].bgColorForIntPaidThisCheck = '16777215';
    summaryGirdRowData[0].disabledForIntPaidThisCheck = summaryGirdRowData[0]
      .disabledForIntPaidThisCheck
      ? true
      : false;
  }
  const isDisabledIntPaid = summaryGirdRowData[0].disabledForIntPaidThisCheck;
  summaryGirdRowData[0].intPaidThisCheck = isDisabledIntPaid
    ? parseFloat(calcuNewIntStld)?.toFixed(2)
    : parseFloat(summaryGirdRowData[0].intPaidThisCheck)?.toFixed(2);
  // if (!newOwedAmt) newOwedAmt = 0;
  if (interestObj) summaryGirdRowData[0].interestPaid = parseFloat(interestObj);
  else interestObj = parseFloat(summaryGirdRowData[0].interestPaid);
  // dispatch(
  //   dispatchGetSummaryGridList([], activeInvNum, activeCheckLogNum, false)
  // );
  summaryGirdAllData[`${activeInvNum}-${activeCheckLogNum}`] =
    summaryGirdRowData;
  dispatch(
    dispatchGetSummaryGridList(
      summaryGirdAllData,
      activeInvNum,
      activeCheckLogNum,
      false
    )
  );
  // setTimeout(
  //   () =>
  //     dispatch(
  //       dispatchGetSummaryGridList(
  //         summaryGirdAllData,
  //         activeInvNum,
  //         activeCheckLogNum,
  //         false
  //       )
  //     ),
  //   100
  // );
  const tempObj = headerAllocatePaymentData;
  const isTotalAllocateAmt =
    tempObj[`${activeInvNum}-${activeCheckLogNum}`].totAllocatedAmt;
  if (newIntStld) {
    let totalAlAmt = allocatePaymentHeaderDetail?.originalTotAllocatedAmt;
    totalAlAmt = parseFloat(
      parseFloat(totalAlAmt || 0) + parseFloat(newIntStld || 0)
    ).toFixed(2);
    if (isDisabledIntPaid) {
      tempObj[`${activeInvNum}-${activeCheckLogNum}`].totAllocatedAmt =
        totalAlAmt;
    } else {
      tempObj[`${activeInvNum}-${activeCheckLogNum}`].totAllocatedAmt =
        isTotalAllocateAmt;
    }
    tempObj[`${activeInvNum}-${activeCheckLogNum}`].isPQASScreen = true;
    await dispatch(
      dispatchAllocatePaymentHederData(
        tempObj,
        activeInvNum,
        activeCheckLogNum,
        true
      )
    );
    // Not using the state value
    // setTimeout(() => {
    //   dispatch(dispatchAllocatePaymentAmtNotify({ isPQASScreen: true }));
    // }, 100);
  } else if (isTotalAllocateAmt && isTotalAllocateAmt != 0) {
    dispatch(
      dispatchAllocatePaymentHederData(
        headerAllocatePaymentData,
        activeInvNum,
        activeCheckLogNum,
        true
      )
    );
    // setTimeout(() => {
    //   dispatch(dispatchAllocatePaymentAmtNotify({ isPQASScreen: true }));
    // }, 100);
  }
};

export const PQASGRidTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_150,
    maxWidth: Styles.Width_150,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Paid In Full',
    field: 'ccPaidInFullInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'PaidInFullCheckBoxRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    fillBackgroundColorCol: 'bgColorForPaidInFullInd',
    showBackgroundColor: true,
    // cellClassRules: {
    //   // 'green-legend': (params) =>
    //   //   params.data?.bgColorForPaidInFullInd?.toString() === '00b300', // green color
    //   'white-legend': (params) =>
    //     params.data?.bgColorForPaidInFullInd?.toString() === '16777215', // white color
    //   'grey-legend': (params) =>
    //     params.data?.bgColorForPaidInFullInd?.toString() === '12632256', // grey color
    // },
  },
  {
    headerName: 'Interest Settled',
    field: 'interestSettledInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'InterestSettledCheckBoxRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Int. Calc',
    field: 'interestCalc',
    cellClass: 'frr-input-width-80per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    cellRenderer: 'InterestCalCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isBgColor: true,
    bgColorName: 'bgColorForInterestCalc',
  },
  {
    headerName: 'Int. Paid',
    field: 'ccInterestAllocated',
    cellClass: 'frr-input-width-80per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'InterestPaidCellRender',
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      const colName = 'currUnitRebateAmt';
      if (e.key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('PQAS-670');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
        });
      }
    },
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    sort: 'asc',
    removeuuidNDC: true,
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NDCCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColorForNDC?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColorForNDC?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterValueGetter: (params) => {
      if (params.data?.isBottomRow) return '';
      return removeWhiteSpaceForNDC(params.data?.ndc) ?? '';
    },
    isBgColor: true,
    bgColorName: 'bgColorForNDC',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: ndcTextMatcher,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    cellClass: 'frr-input-width-93per',
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DrugNameCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColorForNDC?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColorForNDC?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForNDC',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Original URA',
    field: 'cidunitRebateAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_160,
    exportZeroSix: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'OrgURACellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForOrgURA',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current URA',
    field: 'currUnitRebateAmt',
    comparator: amountComparator,
    cellClass: '',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: ' ',
    minWidth: Styles.Width_160,
    exportZeroSix: true,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'currURACellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForCurrURA',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Units Invoiced',
    // field: 'xorigCurrUnitsPaid',
    field: 'totReimbursedUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    minWidth: Styles.Width_190,
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    exportZeroesFour: true,
    cellRenderer: 'orgUnitsInvoicedCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForOrgUnitsInv',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units',
    field: 'currUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    excelAlignment: 'right',
    exportZeroesFour: true,

    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'currentUnitsCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForCurrUnits',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Units Paid',
    field: 'priorPaidUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    excelAlignment: 'right',
    exportZeroesFour: true,

    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'priorPaidUnitsCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForPriorUnitsPaid',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units Paid',
    field: 'currUnitsPaid',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    excelAlignment: 'right',
    minWidth: Styles.Width_180,
    exportZeroesFour: true,

    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'currUnitsPaidCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForCurrUnitsPaid',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Units Disputed',
    field: 'priorDisputedUnits',
    cellClass: 'frr-input-width-93per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    excelAlignment: 'right',
    minWidth: Styles.Width_200,
    exportZeroesFour: true,

    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'priorDisputedUnitsCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForPriorUnitsDisputed',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Units Disputed',
    field: 'currUnitsDisputed',
    cellClass: 'frr-input-width-93per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    dataAlignRight: true,
    exportZeroesFour: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '',
    excelAlignment: 'right',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'currUnitsDisputedCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForCurrUnitsDisputed',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Amt Invoiced',
    field: 'xorigAmtPtt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-85per',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'orgAmtInvoicedCellRender',
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForOrgInvAmt',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Revised Invoice Amount',
    field: 'revisedInvoiceAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-85per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'revisedInvoiceAmtCellRender',
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForRevisedInvAmt',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prior Amount Paid',
    field: 'priorPaidAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-85per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'priorPaidAmtCellRender',
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForPriorAmtPaid',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Current Amount Paid',
    field: 'currAmtPaid',
    comparator: amountComparator,
    cellClass: 'frr-input-width-85per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'currAmtPaidCellRender',
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForCurrAmtPaid',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount Paid this Transaction',
    field: 'paidThisTransactionAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-90per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    dataAlignRight: true,
    cellRenderer: 'paidThisTransactionAmtCellRender',
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      const colName = 'ccAc1';
      if (e.key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('PQAS-1357');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.focus();
          }
        });
      }
    },
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
          textAlign: 'right',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
          textAlign: 'right',
        };
      }
      return { 'border-right-color': Styles.BorderColor, textAlign: 'right' };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    isBgColor: true,
    bgColorName: 'bgColorForAmtPaidThisTran',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adj Code 1',
    field: 'ccAc1',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode1CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc1',
    // dropDownValueCol: 'ccAc1ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc1ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc1'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'ADJ Code 2',
    field: 'ccAc2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode2CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc2',
    // dropDownValueCol: 'ccAc2ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc2ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc2'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'ADJ Code 3',
    field: 'ccAc3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode3CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc3',
    // dropDownValueCol: 'ccAc3ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc3ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc3'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 1',
    field: 'ccDc1',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode1CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc1',
    // dropDownValueCol: 'ccDc1ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc1ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc1'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 2',
    field: 'ccDc2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode2CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc2',
    // dropDownValueCol: 'ccDc2ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc2ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc2'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 3',
    field: 'ccDc3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode3CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc3',
    // dropDownValueCol: 'ccDc3ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc3ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc3'),
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
];

export const PQASSummaryGridTableHead = [
  {
    headerName: 'Current Principal Amount',
    field: 'currentPrincipalAmt',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CurrentPrincipalAmtCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Interest Calculated',
    field: 'totalInterestCalc',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TotalInterestCalcCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Principal Paid',
    field: 'totalPrincipalPaid',
    cellClass: 'frr-input-width-93per',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    // printPrefixValue: '$',
    dataAlignRight: true,
    cellRenderer: 'totalPrincipalPaidThisCheckRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Principal Paid: This check',
    field: 'principalPaidThisCheck',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'principalPaidThisCheckRenderer',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Int. Paid',
    field: 'totalIntPaid',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TotalIntPaidCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Total Int. Settled',
    field: 'totalIntSettled',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TotalIntSettledCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    // printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Interest Paid: This check',
    field: 'intPaidThisCheck',
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'interestPaidThisCheckCellRender',
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    dataAlignRight: true,
    sortingOrder: ['desc', 'asc'],
    isTextColorRed: true,
    printPrefixValue: '$',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
